import { useApplicantHelpers } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantHelpers";
import SectionTitle from "@Client/@Modules/application-standalone/components/helpers/section-title.vue";
import PageSummarySectionGroupLayout from "@Client/@Modules/application-standalone/components/layout/page-summary-section-group-layout.vue";
import { computed, defineComponent, onMounted, ref, watch } from "@vue/composition-api";
import { useApplicationStandaloneStoreGetters } from "@Client/@Modules/application-standalone/store/application-standalone-helpers";
import * as ApplicationStandaloneGetters from "@Client/@Modules/application-standalone/store/application-standalone-getters";
import { useValidatorsHelper } from "@Client/@Composables/application-standalone/validations/useValidatorsHelper";
import ApplicationSectionErrorIcon from "@Client/@Modules/application-standalone/components/helpers/application-section-error-icon.vue";
import { useSummaryHelpers } from "@Client/@Composables/application-standalone/pages/summary/useSummaryHelpers";
import RemoveComponentModal from "./../remove-component-modal.vue";
import { useI18n } from "vue-i18n-composable";
export default defineComponent({
  name: "ApplicantsSummary",
  components: {
    PageSummarySectionGroupLayout,
    SectionTitle,
    ApplicationSectionErrorIcon,
    RemoveComponentModal
  },
  props: {
    showErrors: {
      type: Number,
      default: 0
    }
  },
  setup(props, {
    emit
  }) {
    const invalidApplicants = ref([]);
    const {
      getInvalidApplicants
    } = useValidatorsHelper();
    const {
      t
    } = useI18n();
    const {
      allApplicants,
      addEmptyCoApplicant,
      deleteCoApplicant,
      applicantNameFromIndex,
      isApplicantVisibleFromFillOut
    } = useApplicantHelpers();
    const {
      IS_FILL_OUT
    } = useApplicationStandaloneStoreGetters([ApplicationStandaloneGetters.IS_FILL_OUT]);
    const {
      editButtonText,
      allowEdit
    } = useSummaryHelpers();
    onMounted(() => {
      updateInvalidApplicants();
    });
    const updateInvalidApplicants = async () => {
      invalidApplicants.value = await getInvalidApplicants();
    };
    const areInvalidApplicants = computed(() => !!invalidApplicants.value.length);
    watch(areInvalidApplicants, newValue => {
      emit("disable-save", newValue);
    }, {
      immediate: true
    });
    const handleAddAnotherApplicant = () => {
      addEmptyCoApplicant();
      emit("navigate", {
        applicantIndex: allApplicants.value.length - 1
      });
    };
    const firstErrorId = computed(() => {
      var _invalidApplicants$va, _invalidApplicants$va2, _invalidApplicants$va3;
      return (_invalidApplicants$va = (_invalidApplicants$va2 = invalidApplicants.value) == null ? void 0 : (_invalidApplicants$va3 = _invalidApplicants$va2[0]) == null ? void 0 : _invalidApplicants$va3.id) != null ? _invalidApplicants$va : null;
    });
    const handleNavigation = (applicantIndex, applicantId = "") => {
      emit("navigate", {
        applicantIndex,
        applicantId
      });
    };
    const getApplicantEmail = applicant => {
      var _applicant$personalD;
      return (applicant == null ? void 0 : (_applicant$personalD = applicant["personal-details"]) == null ? void 0 : _applicant$personalD["email"]) || "";
    };
    const isInvalid = applicant => {
      return invalidApplicants.value.some(({
        id
      }) => id === applicant.id);
    };
    const handleDelete = ({
      applicantIndex
    }) => {
      deleteCoApplicant(applicantIndex - 1);
      updateInvalidApplicants();
    };
    const modalText = computed(() => {
      return t("application-form.removeComponentModalMessage", {
        componentType: "co-applicant"
      });
    });
    const removeComponentModal = ref();
    const openDeletionModal = data => {
      var _removeComponentModal;
      removeComponentModal == null ? void 0 : (_removeComponentModal = removeComponentModal.value) == null ? void 0 : _removeComponentModal.openModal(data);
    };
    return {
      handleDelete,
      handleNavigation,
      handleAddAnotherApplicant,
      allApplicants,
      applicantNameFromIndex,
      getApplicantEmail,
      deleteCoApplicant,
      isApplicantVisibleFromFillOut,
      isInvalid,
      IS_FILL_OUT,
      invalidApplicants,
      editButtonText,
      allowEdit,
      updateInvalidApplicants,
      firstErrorId,
      modalText,
      openDeletionModal,
      removeComponentModal
    };
  }
});